import { render, staticRenderFns } from "./AddressLogs.vue?vue&type=template&id=0c7b22ec&scoped=true&"
import script from "./AddressLogs.vue?vue&type=script&lang=js&"
export * from "./AddressLogs.vue?vue&type=script&lang=js&"
import style0 from "./AddressLogs.vue?vue&type=style&index=0&id=0c7b22ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b22ec",
  null
  
)

export default component.exports